import axios, {AxiosResponse, CancelTokenSource} from "axios";
import {ISuggestResult, ISuggestResults} from "./EnterAddressView";

export function searchAddresses(value: string, completion: (results: Array<ISuggestResult>) => void, source: CancelTokenSource) {
    const params = new URLSearchParams();
    params.append('outformat', "json");
    params.append('v', "9");
    params.append('text', value);
    params.append('countries', 'ru')

    axios.get("https://suggest-maps.yandex.ru/suggest-geo", {
        params: params,
        cancelToken: source.token
    })
        .then((s: AxiosResponse<ISuggestResults>) => completion(s.data.results))
        .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
            } else {
                // handle error
            }
        });
}

export interface IGeocodedAddress {
    coords: Array<number>
    text: string
}

export function geocodeAddress(query: string, completion: (address: IGeocodedAddress) => void, source: CancelTokenSource) {
    const params = new URLSearchParams();
    // params.append('kind', "house");
    params.append('format', "json");
    params.append('apikey', '14e9e68d-955b-4f58-b08c-16fb58df1898');
    params.append('geocode', query);

    axios.get("https://enterprise.geocode-maps.yandex.ru/1.x/", {
        params: params,
        cancelToken: source.token
    })
        .then((s: AxiosResponse<any>) => {
            let data = s.data["response"]["GeoObjectCollection"]['featureMember'];
            if (data.length !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                let geoObject = data[0]["GeoObject"]
                let pos = geoObject["Point"]["pos"].split(" ");
                console.log(geoObject)
                completion({coords: pos, text: geoObject["name"] ?? ""})
            }
        })
        .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
            } else {
            }
        });
}
